import React from 'react'

type Props = {
  title?: string
  message: string
  shadowColor?: string
}

export function WooNotesErrorAlert({ title = 'Login failed', message, shadowColor }: Props) {
  if (!message) return null

  return (
    <div
      style={{
        padding: '14px 16px',
        borderRadius: 16,

        border: `2px solid ${shadowColor ?? '#A63D2E'}`,

        background: 'linear-gradient(180deg, #FFB4A2 0%, #FF8A6A 55%, #F65C4A 100%)',

        color: '#3B0B05',

        boxShadow: `
  0 6px 0 ${shadowColor ?? '#7F2A1E'},
  0 12px 22px rgba(80,20,12,0.35)
`,

        display: 'flex',
        gap: 12,
        alignItems: 'flex-start',

        animation: 'wooShake 300ms ease',
      }}
    >
      {/* Icon */}
      <div style={{ fontSize: 22, lineHeight: '22px' }}>⚠️</div>

      <div style={{ display: 'grid', gap: 4 }}>
        {!!title && <div style={{ fontWeight: 900 }}>{title}</div>}
        <div style={{ fontWeight: 700 }}>{message}</div>
      </div>

      <style>{`
        @keyframes wooShake {
          0% { transform: translateX(0); }
          25% { transform: translateX(-4px); }
          50% { transform: translateX(4px); }
          75% { transform: translateX(-2px); }
          100% { transform: translateX(0); }
        }
      `}</style>
    </div>
  )
}
